import { FormattedMessage } from 'react-intl';
import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import { IconTile } from '@atlaskit/icon';

import IconWithContent from '../IconWithContent';
import { useInfo } from '../../../Flow/ConsentContextProvider';

const Vendor = () => {
  const { client } = useInfo();
  const company = client?.appVendorName ?? '<COMPANY>';

  return (
    <IconWithContent
      text={
        <FormattedMessage
          id="trello.vendor.main"
          defaultMessage="Operated by {company}"
          description="Compliance disclaimer."
          values={{ company: <strong>{company}</strong> }}
        />
      }
      icon={
        <IconTile
          icon={CheckCircleIcon}
          label=""
          appearance="gray"
          size="medium"
        />
      }
    />
  );
};

export default Vendor;
